import { h, Component } from 'preact';

export default class ChatFrame extends Component {

    shouldComponentUpdate() {
        // do not re-render via diff:
        return false;
    }

    render({intergramId, host, iFrameSrc, isMobile, conf},{}) {
        let dynamicConf = window.intergramOnOpen || {}; // these configuration are loaded when the chat frame is opened
        // Pass isMobile through so the chat (in the iframe) can show a send button on mobile,
        // where a media query can't tell the fullscreen mobile frame from the narrow desktop one.
        let encodedConf = encodeURIComponent(JSON.stringify({...conf, ...dynamicConf, isMobile}));
        return (
            <iframe src={iFrameSrc + '?id=' + intergramId + '&host=' + host + '&conf=' + encodedConf }
                    frameborder='0'
                    style={{
                        flex: '1',
                        width: '100%',
                        height: 0,
                    }}>
            </iframe>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widget/chat-frame.js